module.exports = __webpack_public_path__ + "named-71d9483bd4e768909d0af177745c2f5d-favicon.svg";